import {CreateTokenResponse, User} from "./types";
import {useEffect, useState} from "react";
import {login} from "./user-actions";

export enum OperatorEventType {
    loginToken = "loginToken",
    logout = "logout",
    cashierOpenRequested = "cashierOpenRequested"
}

export type OperatorEvent =
    { action : OperatorEventType.loginToken, loginToken : string } |
    { action : OperatorEventType.logout, reason : string|undefined, url : string|undefined} |
    { action : OperatorEventType.cashierOpenRequested}

const postMessageToPoker = (message : OperatorEvent) => {
    if (window.parent) {
        console.log("Posting event to poker = ", message);
        window.parent.postMessage(message, "*");
    } else {
        console.log("No parent to post event to", message);
    }
}
export const PokerDesktopComponent = (props : { user : User, logout : () => void }) => {
    console.log("PokerDesktopComponent start");
    const [showCashier, setShowCashier] = useState(false);
    const [tokenError, setTokenError] = useState(false)
    const [token, setToken] = useState("");


    useEffect(()=>{
        console.log("Mounting PokerDesktopComponent");
        //fetch poker login token from server
        login(props.user).then((data : CreateTokenResponse) => {
            console.log("CreateTokenResponse = ", data);
                setToken(data.token);
                const loginEvent : OperatorEvent = {
                    action : OperatorEventType.loginToken,
                    loginToken : data.token
                }
                postMessageToPoker(loginEvent);
        }).catch((e) => {
            console.log("Token error", e);
            setTokenError(true)
        })

        const listener = (e : MessageEvent<OperatorEvent>) => {
            if (e.data.action === OperatorEventType.cashierOpenRequested) {
                setShowCashier(true);
            } else if (e.data.action === OperatorEventType.logout) {
                props.logout();
            }
        }

        window.addEventListener("message", listener);

        return () => {
            window.removeEventListener("message", listener)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    if (tokenError) {
        return (
            <div className={"alert alert-danger"}>
                Unable to create poker login token {document.location.host} {document.location.port}
            </div>
        )
    } else if (showCashier) {
        return (
            <div className={"container"} style={{ margin : "50px auto", maxWidth: "400px"}}>
                <div className={"alert alert-info"}>
                    This demo site does not have a cashier since you have infinite money!
                </div>
            </div>
        )
    } else if (token){
        console.log("Token valid = ", token);
    }

    return (
        <div>

        </div>
    )

}